<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="mb-0">Pakete</h1>
    </div>

    <DataTable
      :value="packagesStore.items"
      :rows="packagesStore.serverOptions.rows"
      :totalRecords="packagesStore.totalRecords"
      :loading="packagesStore.loading"
      :lazy="true"
      :sortField="packagesStore.serverOptions.sortField"
      :sortOrder="packagesStore.serverOptions.sortOrder"
      paginator
      removableSort
      dataKey="id"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[20,50,100]"
      currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords}"
      responsiveLayout="scroll"
      @page="onPage"
      @sort="onSort"
    >
      <template #empty>
        Keine Pakete gefunden.
      </template>

      <TableColumn field="id" header="ID" sortable />

      <TableColumn field="base_type" header="Basis-Typ" sortable>
        <template #body="{ data }">
          {{ data.base_type || '-' }}
        </template>
      </TableColumn>

      <TableColumn field="quantity" header="Menge" sortable>
        <template #body="{ data }">
          {{ data.quantity ?? '-' }}
        </template>
      </TableColumn>

      <TableColumn field="price_cents" header="Preis" sortable>
        <template #body="{ data }">
          <PriceAmount :cents="data.price_cents" inline />
        </template>
      </TableColumn>

      <TableColumn field="ends_at" header="Endet am" sortable>
        <template #body="{ data }">
          {{ formatDateValue(data.ends_at) }}
        </template>
      </TableColumn>

      <TableColumn header="Aktionen">
        <template #body="{ data }">
          <router-link
            class="d-inline-flex align-items-center"
            title="bearbeiten"
            :to="{name: 'admin.packages.edit', params: {id: data.id}}"
          >
            <ActionIcon icon="fa-pro-solid:pencil" />
          </router-link>
        </template>
      </TableColumn>
    </DataTable>
  </div>
</template>

<script>
import { usePackagesStore } from "@/stores/packages";
import dayjs from "dayjs";
import ActionIcon from "@/components/general/ActionIcon.vue";
import PriceAmount from "@/components/general/PriceAmount.vue";

export default {
  name: "PackagesIndex",
  components: {
    ActionIcon,
    PriceAmount,
  },
  setup() {
    return {
      packagesStore: usePackagesStore(),
    }
  },
  created() {
    this.packagesStore.index()
  },
  methods: {
    onPage(event) {
      this.packagesStore.serverOptions = {
        ...this.packagesStore.serverOptions,
        ...event,
      }
      this.packagesStore.index()
    },
    onSort(event) {
      this.packagesStore.serverOptions = {
        ...this.packagesStore.serverOptions,
        sortField: event.sortField || 'id',
        sortOrder: event.sortOrder || -1,
      }
      this.packagesStore.index()
    },
    formatDateValue(value) {
      return value ? dayjs(value).format('DD.MM.YYYY') : '-'
    },
  },
}
</script>
